export default __webpack_public_path__ + "static/media/2136.9568c412.jpg";